import React from "react";
import { Table } from "antd";
import { useSelector } from "react-redux";

function BLEDetails() {
  const deviceName = useSelector((state) => state?.shipment?.data?.deviceName);
  const shipmetProfile = useSelector((state) => state?.shipment?.data?.shipProfile);
  const { editField } = useSelector((state) => ({
    editField: state.shipment.ui.editShipment,
  }));
function getValueByUidAndKey(uid, key) {
    const item = deviceName?.devices?.find(obj => obj.uid === uid);
    return item ? item[key] : null;
}
function getShipmentByid(profileid, key) {
  const item = shipmetProfile?.find(obj => obj.profileid === profileid);
  return item ? item[key] : null;
}
const blecolumns = [
  {
  title: (
      <>
      <span className="font-face-vzw">BLE device ID</span>
      </>
  ),
    dataIndex: "bledeviceid",
    key: "bledeviceid",
    width: 140,
    onHeaderCell: () => ({
      "data-tooltip": "",
    }),
    render: (text) => {
      return text;
    },
  },
  {
  title: (<span className="font-face-vzw">Device name</span>),
    dataIndex: "devicename",
    key: "devicename",
    onHeaderCell: () => ({
      "data-tooltip": "", 
    }),
    render: (text) => {
      return text;
    },
  },
  {
  title: (<span className="font-face-vzw">Model</span>),
     dataIndex: "devicemodel",
    className: "state",
    render: (text) => <span>{text}</span>,
    key: "devicemodel",
  },
  {
  title: (<span className="font-face-vzw">Device profile</span>),
    dataIndex: "revdeviceProfile",
    width: 140,
    key: "revdeviceProfile",
    onHeaderCell: () => ({
      "data-tooltip": "",
    }),
    render: (text, record) => <span>{getShipmentByid(text, "profilename") }</span>,
  },
];
const bleprofileData = editField?.ble?.map(item => ({
  bledeviceid: getValueByUidAndKey(item?.uid, "minor") ?? getValueByUidAndKey(item?.uid, "serial"),
  devicename:  getValueByUidAndKey(item?.uid, "name"),
  devicemodel: getValueByUidAndKey(item?.uid, "devicetype"),
  revdeviceProfile: item?.deviceProfile,
}));
  return (
    <>
      <div
        className="font-face-vzw py-1"
        style={{
          fontWeight: 700,
          fontSize: "20px",
          color: "#6F7171",
        }}
      >
        BLE details
      </div>
      <Table 
      columns={blecolumns}
      dataSource={bleprofileData}
      pagination={false} />
    </>
  );
}

export default BLEDetails;
